import React, { FC } from 'react';
import { Card, Table, TableBody, TableContainer } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { observer } from 'mobx-react-lite';
import { TableHeader } from 'src/UIKit/TableHeader';
import { forceUpdateModel } from '../../../entity/platforms/ForceUpdateModel';
import { useForceUpdateTable } from '../../../presenters/useForceUpdateTable';
import { PlatformTableRow } from '../tableRow';

export const ForceUpdateTable: FC = observer(() => {
    const { t } = useUiContext();
    useForceUpdateTable();
 
    const TABLE_HEAD = [
        t('force_update.name'), 
        t('force_update.min_version'), 
        t('force_update.recommended_version'), 
        t('force_update.link'),
    ];

    return (
        <Card>
            <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                    <TableHeader headLabels={TABLE_HEAD} />
                    <TableBody>
                        {forceUpdateModel.platforms?.map((item) => (<PlatformTableRow item={item} key={item.id} />))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
})
